export const DELETE_VALUE = "DELETE_VALUE";
export const VALUE_CHANGED = "VALUE_CHANGED";
export const FETCH_GENRES = "FETCH_GENRES";
export const FETCH_GENRES_FAILED = "FETCH_GENRES_FAILED";
export const FETCH_GENRES_SUCCEEDED = "FETCH_GENRES_SUCCEEDED";
